import { IconFilter } from "@tabler/icons-react";
import { Button, Popover, Space } from "antd";
import type React from "react";
import { CustomIcon } from "./base";

/**
 * Wraps a table's filter fields for narrow screens: shown inline when there's room,
 * collapsed behind a "Filters" popover button when `isCompact`. The fields themselves
 * are the caller's business — this only owns the responsive show/hide behavior.
 */
export function TableFilterBar({
	isCompact,
	children,
}: {
	isCompact: boolean;
	children: React.ReactNode;
}) {
	// Wrapped in its own Space: returned bare, the fields land in a single item of the table
	// toolbar's Space and render with no gap between them.
	if (!isCompact) return <Space wrap>{children}</Space>;

	return (
		<Popover
			trigger="click"
			placement="bottomLeft"
			content={
				<Space orientation="vertical" style={{ width: 220 }}>
					{children}
				</Space>
			}
		>
			<Button icon={<CustomIcon icon={IconFilter} />}>Filters</Button>
		</Popover>
	);
}
